var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Collection',{attrs:{"cards":_vm.collection,"title":decodeURIComponent(_vm.pArtist),"cardsPerRow":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }